import type { SessionStatus } from '@/types';

const SESSION_CLASS: Record<SessionStatus, string> = {
  pending: 'is-pending',
  active: 'is-active',
  completed: 'is-completed',
  error: 'is-error',
};

export function SessionBadge({ status }: { status: SessionStatus }) {
  const pulse = status === 'active' ? ' pulse' : '';
  return (
    <span className={`badge ${SESSION_CLASS[status]}`}>
      <span className={`dot${pulse}`} />
      {status}
    </span>
  );
}

export function AgentBadge({ online }: { online: boolean }) {
  return (
    <span className={`badge ${online ? 'is-online' : 'is-offline'}`}>
      <span className={`dot${online ? ' pulse' : ''}`} />
      {online ? 'online' : 'offline'}
    </span>
  );
}

// PASS/FAIL verdict pill. `verdict` is null when no thresholds were set.
export function VerdictBadge({ verdict }: { verdict?: 'pass' | 'fail' | null }) {
  if (verdict !== 'pass' && verdict !== 'fail') return null;
  const pass = verdict === 'pass';
  return (
    <span
      className="badge"
      style={{
        background: pass ? 'rgba(52,240,168,0.14)' : 'rgba(255,93,108,0.16)',
        color: pass ? 'var(--signal)' : 'var(--loss)',
        fontWeight: 700,
        letterSpacing: 1,
      }}
    >
      {pass ? 'PASS' : 'FAIL'}
    </span>
  );
}
